import CustomerAgentListDto from './../../../dtos/customeragentmodule/CustomerAgentListDto';

class GetCustomerAgentResult {
    CustomerAgent: CustomerAgentListDto;

    constructor(customerAgent: CustomerAgentListDto) {
        this.CustomerAgent = customerAgent;
    }
}

export default GetCustomerAgentResult;
